/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_ResubscribeInputs */

const en_plan_resubscribe = /** @type {(inputs: Plan_ResubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resubscribe now`)
};

const es_plan_resubscribe = /** @type {(inputs: Plan_ResubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resuscribirse ahora`)
};

/**
* | output |
* | --- |
* | "Resubscribe now" |
*
* @param {Plan_ResubscribeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_resubscribe = /** @type {((inputs?: Plan_ResubscribeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_ResubscribeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_resubscribe(inputs)
	return en_plan_resubscribe(inputs)
});